import React from "react";
import * as Icons from "lucide-react";
import { motion } from "framer-motion";
import { SectionHeading } from "./shared";
import { INDUSTRIES } from "../data";

export const Industries = () => {
  return (
    <section id="industrii" className="bg-white py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          center
          eyebrow="Cui ne adresăm"
          title="Soluții pentru fiecare tip de organizație"
          subtitle="Indiferent de forma juridică sau dimensiunea afacerii, avem experiența potrivită pentru tine."
        />

        <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
          {INDUSTRIES.map((ind, i) => {
            const Icon = Icons[ind.icon] || Icons.Circle;
            return (
              <motion.div
                key={ind.title}
                data-testid={`industry-card-${i}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                whileHover={{ y: -6 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.45, delay: (i % 4) * 0.06, ease: [0.22, 1, 0.36, 1] }}
                className="group flex flex-col items-center text-center rounded-2xl border border-gray-100 bg-[#F8F9FA] px-5 py-8 hover:bg-white hover:border-brand/30 hover:shadow-card transition-[background-color,border-color,box-shadow] duration-300"
              >
                <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white text-brand shadow-subtle ring-1 ring-black/5 group-hover:bg-brand group-hover:text-white transition-colors duration-300">
                  <Icon className="h-7 w-7" strokeWidth={1.6} />
                </span>
                <h3 className="mt-4 text-base font-semibold text-ink">{ind.title}</h3>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
